import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { MediumText } from "../Typography";
import { VerticalSpacing } from "../VerticalSpacing";
import { MarketingCarouselUserCard, MarketingCarouselUserHeader, MarketingCarouselUserImg, MarketingCarouselUserTag, MarketingCarouselUserBody } from "./MarketingCarouselUser.styles";

export interface CarouselUserPledge {
    name: string,
    handle: string,
    pledge: JSX.Element,
    url: string,
}

export const UserCard = ({ userPledge, index }: { userPledge: CarouselUserPledge, index: number }) => {
    return <UnstyledLink target="_blank" href={userPledge.url}>
        <MarketingCarouselUserCard>
            <MarketingCarouselUserHeader>
                <div>
                    <MarketingCarouselUserImg src={`/authory_static_files/images/homepage/tweets/user_${index}.png`} />
                </div>
                <div>
                    <MediumText><strong>{userPledge.name}</strong></MediumText>
                    <VerticalSpacing top={10}>
                        <MarketingCarouselUserTag>{userPledge.handle}</MarketingCarouselUserTag>
                    </VerticalSpacing>
                </div>
            </MarketingCarouselUserHeader>
            <div>
                <VerticalSpacing top={15}>
                    <MarketingCarouselUserBody>{userPledge.pledge}</MarketingCarouselUserBody>
                </VerticalSpacing>
            </div>
        </MarketingCarouselUserCard>
    </UnstyledLink>
}